import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a39f345"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Filtrer på felt", -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<option value=\"all\" data-v-6a39f345>Alle</option><option value=\"stock\" data-v-6a39f345>Lagerstatus</option><option value=\"name\" data-v-6a39f345>Navn</option><option value=\"description\" data-v-6a39f345>Beskrivelse</option><option value=\"price\" data-v-6a39f345>Utpris (eks. mva)</option><option value=\"cost\" data-v-6a39f345>Innpris</option>", 6)
const _hoisted_9 = [
  _hoisted_3
]
const _hoisted_10 = {
  key: 0,
  class: "changelogs"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-6a39f345><p class=\"label\" data-v-6a39f345>Dato</p><p class=\"label\" data-v-6a39f345>Felt</p><p class=\"label\" data-v-6a39f345>Bruker</p><p class=\"label\" data-v-6a39f345>Ordre</p><p class=\"label\" data-v-6a39f345>Verdi før endring</p><p class=\"label\" data-v-6a39f345>Verdi etter endring</p></div>", 1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Ingen endringer loggført enda", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "pagination-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Changelog = _resolveComponent("Changelog")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onAction: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterResults && _ctx.filterResults(...args)), ["prevent"]))
      }, null, 32),
      _hoisted_2,
      _withDirectives(_createElementVNode("select", {
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterResults && _ctx.filterResults(...args))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterForm.field) = $event))
      }, _hoisted_9, 544), [
        [_vModelSelect, _ctx.filterForm.field]
      ])
    ]),
    (_ctx.changelogsData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changelogsData, (changelog) => {
            return (_openBlock(), _createBlock(_component_Changelog, { changelog: changelog }, null, 8, ["changelog"]))
          }), 256))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Pagination, {
        class: "pagination",
        size: "lg",
        paginate: _ctx.changelogs
      }, null, 8, ["paginate"])
    ])
  ]))
}